import cn from 'classnames';
import styles from './LoginToSeeProfile.module.css';
import { useRouter } from 'next/router';
import getConfig from 'next/config';

const {
    publicRuntimeConfig: { baseUrl, contextPath },
} = getConfig();

export const LoginToSeeProfile = () => {
    const router = useRouter();
    const redirectUrl = encodeURIComponent(`${baseUrl}${contextPath}${router.asPath}`);
    const loginUrl = `${baseUrl}/auth/login?redirectUrl=${redirectUrl}`;

    return (
        <div data-testid="TrustProfileNotLoggedIn" className="p-16 border rounded-8">
            <div className={cn(styles.profilePublic, 'center')}>
                <div className={styles.avatar}>
                    <img
                        alt="Bilde av en anonym avatar"
                        className="w-[54] h-[54] rounded-full"
                        src="https://images.finncdn.no/dynamic/220x220c/profile_placeholders/default"
                    />{' '}
                </div>
                <div className="flex-col">
                    <h4>Privat utleier</h4>

                    <div className="text-14 mb-8">Du må være logget inn for å se brukerprofiler og sende forespørsler.</div>
                    <a href={loginUrl} className="button button--small button--secondary w-full max-w-full">
                        Logg inn
                    </a>
                </div>
            </div>
        </div>
    );
};
